import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { filter, tap } from 'rxjs';
import { PRIMENG_ES } from '../../public/assets/primeng-es';
import { AnalyticsService } from './core/analytics.service';
import { SiteFooterComponent } from './shared/site-footer/site-footer.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SiteFooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly primeNgConfig = inject(PrimeNG);
  private readonly router = inject(Router);
  private readonly analytics = inject(AnalyticsService);

  ngOnInit(): void {
    this.primeNgConfig.setTranslation(PRIMENG_ES);
    this.analytics.init();
    this.analytics.trackPageView(this.router.url);

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        tap((event) => this.analytics.trackPageView(event.urlAfterRedirects))
      )
      .subscribe();
  }
}
